import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const fmSlice = createSlice({
    name:"fm",
    initialState:{
        isRevamp:false,
    },
    reducers:{
        setIsRevamp(state,action:PayloadAction<boolean>){
            state.isRevamp = action.payload;
            return state
        }
    }
})

export const {setIsRevamp} = fmSlice.actions

export default fmSlice